// extracted by mini-css-extract-plugin
export var button = "_bz-2";
export var iconWrapper = "_bz-0";
export var investigatingIcon = "_bz-1";